import { useMemo } from 'react';

import { getPrimaryContact } from './ContactService';
import type { PhoneNumber } from './ContactTypes';
import type { PhoneNumbersOptions } from './usePhoneNumbers';
import { usePhoneNumbers } from './usePhoneNumbers';

interface PrimaryPhoneNumberState {
    isLoading: boolean;
    hasError: boolean;
    phoneNumber: PhoneNumber | undefined;
}

export const usePrimaryPhoneNumber = (
    options?: PhoneNumbersOptions,
): [PrimaryPhoneNumberState, () => void] => {
    const [{ isLoading, hasError, phoneNumbers }, fetchContacts] = usePhoneNumbers(options);
    const phoneNumber = useMemo(() => getPrimaryContact(phoneNumbers), [phoneNumbers]);

    return [
        {
            isLoading,
            hasError,
            phoneNumber,
        },
        fetchContacts,
    ];
};
